function LegalPage({ title, updated, children }) {
  return (
    <>
      <header className="site-header">
        <div className="container">
          <nav className="navbar px-0 d-flex align-items-center justify-content-between">
            <a className="navbar-brand" href="/">
              <img src="/logo.png" alt="Bhavani Die Casting Private Limited" className="nav-logo" />
            </a>
            <a className="link-brand small" href="/">
              <i className="bi bi-arrow-left me-1" />Back to site
            </a>
          </nav>
        </div>
      </header>

      <section className="legal-hero">
        <div className="container">
          <h1 className="legal-title">{title}</h1>
          {updated && <p className="legal-updated mb-0">Last updated: {updated}</p>}
        </div>
      </section>

      <main className="section">
        <div className="container">
          <div className="legal-content">{children}</div>
        </div>
      </main>
    </>
  );
}

export default LegalPage;
